export const callsTypes = [
	'CASHTRACK-CALL',
	'NEWS-CALL',
	'BLITZ-CALL',
	'WPP-CALL',
	'INTERVIEW-CALL',
];
